import { escapeHTML } from '../../utils/escape.js';

/**
 * Cajón compartido (design.md AD7): `{ id, titulo, cuerpo }` -> overlay +
 * panel + encabezado con label + botón de cierre. Pura función de render —
 * NO hace `escapeHTML` del `cuerpo` (ya es HTML armado por la vista que lo
 * llama, la cual escapa sus propios valores interpolados — AD7: "cada body
 * escapa sus propios valores, el shell sólo el título"). `js/admin.js` es
 * quien monta esto en `#admin-liquidacion-drawer-mount` y cablea el cierre
 * (click en el botón, click en el overlay, Escape).
 *
 * Creada en S4 (adelanta la nominal "Slice S3" del design.md's File Changes
 * table): el ship order real de tasks.md pone S4 ANTES de S3 ("S4 gates
 * S3/S6/S7"), y S4.15 necesita un cajón para "Adelanto" — S3 reutiliza este
 * MISMO shell + el MISMO `#admin-liquidacion-drawer-mount` para su cajón de
 * anomalías (AD7: "Three drawers... one shared shell"), en vez de crearlos.
 *
 * @param {{ id: string, titulo: string, cuerpo: string }} params
 * @returns {string}
 */
export function DrawerShell({ id, titulo, cuerpo }) {
    const headingId = `${id}-titulo`;
    return `
        <div class="fixed inset-0 z-50 flex items-center justify-center" data-drawer-id="${escapeHTML(id)}">
            <div class="absolute inset-0 bg-black/50" data-action="drawer-overlay"></div>
            <div role="dialog" aria-modal="true" aria-labelledby="${escapeHTML(headingId)}" class="relative bg-surface border border-border-subtle rounded-2xl shadow-xl w-full max-w-lg mx-4 max-h-[85vh] overflow-y-auto">
                <div class="flex items-center justify-between px-6 py-4 border-b border-border-subtle">
                    <h2 id="${escapeHTML(headingId)}" class="text-sm font-black uppercase tracking-widest text-text-primary">${escapeHTML(titulo)}</h2>
                    <button type="button" data-action="drawer-cerrar" aria-label="Cerrar" class="text-text-muted hover:text-text-primary text-xl leading-none">&times;</button>
                </div>
                <div class="px-6 py-4">
                    ${cuerpo}
                </div>
            </div>
        </div>
    `;
}
